module.exports = __webpack_public_path__ + "static/media/img-benefit-applewatch-1@2x.674cef23.png";